import { DisparoAutomaticoVariavelModel } from '../model/disparo-automatico/disparo-automatico-variavel.model';
import { TemplateSalvamentoModel } from '../model/template/template-salvamento-model';

export interface CalculoSms {
  isUnicode: boolean;
  caracteres: number;
  sms: number;
}

export function removerAcentos(valor: string): string {
  return (valor ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function calcularSMS(mensagem: string): CalculoSms {
  const texto = mensagem ?? '';
  // eslint-disable-next-line no-control-regex -- faixa de controle intencional p/ detectar caracteres nao ASCII
  const isUnicode = /[^\u0000-\u007F]/.test(texto);
  const caracteres = texto.length;
  const sms = Math.max(1, Math.ceil(caracteres / 160));

  return { isUnicode, caracteres, sms };
}

export function montarMensagemSmsContato(
  template: TemplateSalvamentoModel | undefined,
  variaveis: DisparoAutomaticoVariavelModel[],
  contato: any
): string {
  const corpo = template?.components?.find(componente => componente.type === 'BODY')?.text ?? '';
  const porOrdem = new Map((variaveis ?? []).map(variavel => [variavel.ordem, variavel]));

  const mensagem = corpo.replace(/\{\{\s*(\d+)\s*}}/g, (_, ordemTexto: string) => {
    const variavel = porOrdem.get(Number(ordemTexto));
    return resolverValorVariavel(variavel, contato);
  });

  return removerAcentos(mensagem);
}

function resolverValorVariavel(variavel: DisparoAutomaticoVariavelModel | undefined, contato: any): string {
  if (!variavel) return '';
  if (!variavel.isCampoContato) return variavel.valor ?? '';

  const tipo = removerAcentos(variavel.tipoCampoContato ?? '').toLowerCase();
  if (tipo === 'nome') return contato?.nomeContato ?? contato?.nome ?? '';
  if (tipo === 'e-mail' || tipo === 'email') return contato?.email ?? '';
  if (tipo === 'telefone') return contato?.telefone ?? '';
  if (tipo === 'cpf' || tipo === 'cpf/cnpj' || tipo === 'cpfcnpj') return contato?.cpf ?? '';
  if (variavel.nomeColuna) return buscarCampoComplementar(contato, variavel.nomeColuna);
  return variavel.valor ?? '';
}

function buscarCampoComplementar(contato: any, nomeColuna: string): string {
  const campos = contato?.camposComplementares;
  if (Array.isArray(campos)) {
    return campos.find((campo: any) =>
      (campo.nome ?? campo.nomeColuna)?.localeCompare(nomeColuna, 'pt', { sensitivity: 'base' }) === 0
    )?.valor ?? '';
  }
  if (campos && typeof campos === 'object') {
    const chave = Object.keys(campos).find(nome =>
      nome.localeCompare(nomeColuna, 'pt', { sensitivity: 'base' }) === 0
    );
    return chave ? campos[chave] ?? '' : '';
  }
  return '';
}
